/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useState, useEffect } from 'react';

import { List } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import LeftArrow from '@material-ui/icons/ArrowBackIos';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

import { globals as globalsSlice } from '../../app/globalsSlice';
import { me as meSlice } from '../../pages/AuthenticatedPage/authenticationSlice';
import { SLICE_NAME } from '../../pages/MyAccountPage/constants';
import helpers from '../../pages/SSOPage/SSOHelpers';
import { t } from '../../providers';
import { getLocale, setLocale } from '../../providers';
import ConfirmLogoutDialog from '../Header/ConfirmLogoutDialog';
import LanguageSelect from '../LanguageSelect';
import sidebarItems from './sidebarItems';
import { viewableItems } from './utils';

const useStyles = makeStyles((theme) => ({
    sidebar: {
        marginTop: '0px',
        height: '100%',
        display: 'block',
        flexFlow: 'row nowrap',
        position: 'fixed',
        width: '300px',
        overflowY: 'auto',
        backgroundColor: '#FAFAFA',
        '@media (max-width: 960px)': {
            position: 'unset',
            width: 'auto',
        },
    },
    backArrow: {
        width: '25px',
    },
    sidebarBody: {
        padding: '20px 24px 75px 0px',
        '@media (max-width: 960px)': {
            padding: '0px 24px 75px 0px',
        },
    },
    sidebarHeader: {
        padding: '31px 0px 24px 56px',
        '@media (max-width: 960px)': {
            padding: '31px 0px 24px 40px',
        },
    },
    sidebarTitle: {
        color: '#4D4D4D',
        fontWeight: '600',
        fontSize: '1.25rem',
        lineHeight: '120%',
        fontStyle: 'normal',
        letterSpacing: '0.4px',
    },
    sidebarSubtitle: {
        color: theme.palette.text.outlined,
        fontSize: '0.625rem',
        fontWeight: '600',
        textTransform: 'uppercase',
        lineHeight: '20px',
    },
    sidebarOptions: {},
    sidebarOption: {
        position: 'relative',
        padding: '8px 0px 8px 56px',
        marginBottom: '8px',
        whiteSpace: 'break-spaces',
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
        '@media (max-width: 960px)': {
            padding: '8px 0px 8px 40px',
        },
    },
    sidebarOptionIcon: {
        width: '20px',
        position: 'absolute',
        top: '-2px',
        left: '2px',
        padding: '6px 5px 6px 10px',
    },
    selectedOption: {
        color: theme.palette.text.darkGreen,
        fontWeight: '600',
        fontSize: '0.875rem',
        lineHeight: ' 142%',
        letterSpacing: '0.25px',
    },
    selectedColorOption: {
        background: '#E2EFD5',
    },
    selectedColorItem: {
        fontWeight: '600 !important',
        color: '#223211 !important',
    },
    cursorPointer: {
        cursor: 'pointer',
    },
    sidebarOptionTitle: {
        fontSize: '0.875rem',
        lineHeight: '20px',
        letterSpacing: '0.25px',
        paddingRight: '30px',
    },
    selectedSubmenuOption: {
        color: theme.palette.text.mainGreen,
        fontWeight: '600',
        lineHeight: '20px',
        fontSize: '0.875rem',
    },
    menuItm: {
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
    },
    submenuOption: {
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        padding: '8px 8px 8px 72px',
        fontSize: '0.875rem',
        fontWeight: '400',
        lineHeight: '20px',
        letterSpacing: '0.25px',
        textAlign: 'left',
        color: '#4D4D4D',
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
    },
    rightArrowIcon: {
        marginRight: '10px',
    },
    notSelectedArrow: {
        '& path': {
            fill: theme.palette.primary.main,
        },
    },
    selectedOptionItem: {},
    externalPathIcon: {
        textAlign: 'right',
        color: '#ff0000',
    },
    separator: {
        marginTop: '28px',
    },
    sidebarHideMenu: {
        float: 'right',
    },
    hideMenuButton: {
        height: '20px',
        padding: '0px',
        margin: '0px',
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
        '& svg': {
            fill: '#5D5D5D',
            width: '11px !important',
            marginRight: '-2px',
        },
        '& span': {
            color: '#5D5D5D',
            fontSize: '0.6875rem',
            fontWeight: '400',
            lineHeight: '15px',
            letterSpacing: '0.25px',
            fontStyle: 'normal',
            textTransform: 'uppercase',
        },
    },
    subMenuIcon: {
        display: 'none',
        width: '18px',
        color: '#3F5E20',
    },
    language: {
        background: '#FFFFFF',
        boxShadow: 'inset 0px -1px 0px #E2E4E9',
        borderRadius: '2px',
        margin: '0px 0px 88px 40px',
        width: '125px',
        height: '36px',
        paddingTop: '1px',
    },
}));

const Sidebar = ({ smallDevice, handleSidebarVisibility, showMenu, setShowMenu }) => {
    const classes = useStyles();
    const me = useSelector(meSlice);
    const dispatch = useDispatch();
    const { globals } = useSelector(globalsSlice) || {};
    const [dialogOpen, setDialogOpen] = useState(false);
    let myStorage = window.sessionStorage;
    let userLang = myStorage.getItem('lang');
    const [lang, setLang] = useState(userLang ? userLang : getLocale());
    const languages = Object.keys(globals.supportedLanguages || {}).map((key) => globals.supportedLanguages[key]);
    const [langSelectorIsOpen, setLangSelectorIsOpen] = useState(false);
    const [keyEvent, setKeyEvent] = useState(null);

    let sidebarType = !!(me || {}).userName ? 'auth' : 'unauth';

    const { userType, authorities } = me || {};

    const items = [...sidebarItems[sidebarType]];

    const location = useLocation();
    const history = useHistory();
    const title = {
        main: 'user.area',
    };
    const splittedPath = location.pathname.split('/');
    const rootPath = !!splittedPath.length && `/${splittedPath[1]}`;
    const selectedItem = items.find(({ path }) => path === rootPath);
    title.selected = '';
    if (selectedItem) {
        title.selected = selectedItem.subtitle;
    }
    const selectedLanguage = getLocale();

    const updateLanguage = (event) => {
        const value = event.target.value;
        if (lang === value) return;
        dispatch({ type: `${SLICE_NAME}/updateLanguage`, payload: { language: value } });
        setLang(value);
        let myStorage = window.sessionStorage;
        myStorage.setItem('lang', value);
        setLocale(value);
        const languageSelect = document.getElementById('lng-select');
        if (keyEvent === 'Escape' || keyEvent === 'Enter') {
            languageSelect.focus();
        }
    };

    //set title for forrgotten password page
    title.selected = location.pathname.includes('/forgotten-login') ? 'sign.in' : title.selected;

    // reset token page -- hide sidebarMenu and set sidebar subtitle
    let displaySidebarMenu = true;
    if (location.pathname.includes('/reset/token/')) {
        displaySidebarMenu = false;
        title.selected = 'password.reset';
    }

    const navigateTo = (event, path, externalPath) => {
        event.preventDefault();
        if (smallDevice) {
            handleSidebarVisibility();
        }
        if (path && externalPath) {
            let newPath = path;
            if (!!newPath && !newPath.startsWith('http')) newPath = globals.ipo['fo.url'].concat(globals.ipo[path]);
            if (newPath.indexOf('?') >= 0) {
                newPath += `&lang=${selectedLanguage}`;
            } else {
                newPath += `?lang=${selectedLanguage}`;
            }
            if (!!newPath) window.open(newPath, '_blank');
        } else {
            if (path && location.pathname !== path) {
                history.push(path);
            }
        }
    };

    const logout = (_event) => {
        setDialogOpen(false);
        let myStorage = window.sessionStorage;
        let userLang = myStorage.getItem('lang');
        if (userLang) {
            myStorage.removeItem('lang');
        }
        helpers.logout();
    };

    const cancelLogout = (event) => {
        event.preventDefault();
        setDialogOpen(false);
    };

    const languageSelectOpen = (e) => {
        setLangSelectorIsOpen(true);
        if (e.key === 'Enter') {
            const unSelectedLang = languages.filter((language) => lang !== language.code);
            setTimeout(() => {
                document.getElementById(`${unSelectedLang[0].code}_btn`).focus();
            }, 200);
        }
    };

    useEffect(() => {
        if (langSelectorIsOpen) {
            document.addEventListener('keydown', handleEscapeKey);
        }
    }, [langSelectorIsOpen]);

    const handleEscapeKey = (event) => {
        setKeyEvent(event.key);
    };

    const languageSelectClose = () => {
        setLangSelectorIsOpen(false);
    };

    const displayedItems = viewableItems({
        items,
        navigateTo,
        userType,
        authorities,
        rootPath,
        sidebarType,
        classes,
        location,
        setDialogOpen,
    });
    return (
        <div className={classes.sidebar}>
            <div className={classes.sidebarBody}>
                {smallDevice && (
                    <div className={classes.language}>
                        <LanguageSelect
                            languages={languages}
                            updateLanguage={updateLanguage}
                            langSelectorIsOpen={langSelectorIsOpen}
                            lang={lang}
                            languageSelectClose={languageSelectClose}
                            languageSelectOpen={languageSelectOpen}
                        />
                    </div>
                )}
                <div className={classes.sidebarHideMenu}>
                    <Button
                        disableFocusRipple
                        id="hide-menu-button"
                        onClick={() => (smallDevice ? handleSidebarVisibility() : setShowMenu(!showMenu))}
                        className={classes.hideMenuButton}>
                        <LeftArrow />
                        <span>{t('hide.menu.button')}</span>
                    </Button>
                </div>
                <div className={classes.sidebarHeader}>
                    <div>
                        <Typography className={classes.sidebarTitle}>{t(title.main)}</Typography>

                        {title.selected && (
                            <Typography aria-hidden="true" alt="" variant="h6" className={classes.sidebarSubtitle}>
                                {!!title.selected && t(title.selected)}
                            </Typography>
                        )}
                    </div>
                </div>
                {displaySidebarMenu && (
                    <List component="nav" aria-label="Main" className={classes.sidebarOptions}>
                        {displayedItems}
                    </List>
                )}
                {dialogOpen && <ConfirmLogoutDialog open={dialogOpen} onAccept={logout} onCancel={cancelLogout} />}
            </div>
        </div>
    );
};

export default Sidebar;
